import apiInstance from "../api";
import fileApiInstance from "../fileApi";
import endPoints from "../endpoints";
import { delay } from "../helpers";
import getPlans from "../../mocks/getPlans.json";
import EligilibilityReport from "../../mocks/eligibilityReport.json";
import EligilibilityForecast from "../../mocks/eligibilityForecast.json";
import DeletedParticipant from "../../mocks/deletedParticipant.json";
import GContributionLimit from "../../mocks/GContributionLimit.json";
import ContributionLimit from "../../mocks/contributionLimit.json";
import EmployementStatus from "../../mocks/employementStatus";

export const getReportsDetails = () => {
  // return apiInstance().get(endPoints.plan.get);
  return delay(100).then(() => {
    return getPlans;
  });
};

export const getFileInformationWithErrorDetailsByFileId = (fileId) => {
  return apiInstance().get(
    `${endPoints.reports.getFileInformationWithErrorDetailsById}/${fileId}`
  );
};
export const downloadPlanEligibilityReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadPlanEligibilityDataReport,
    payload
  );
};
export const downloadPayrollWorkloadAnticipationReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadPayrollWorkloadAnticipationReport,
    payload
  );
};
export const downloadPlanListReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadPlanListReport,
    payload
  );
};
export const getDataChangeReport = (fileId) => {
  return apiInstance().get(
    `${endPoints.reports.getDataChangeReport}/${fileId}`
  );
};

export const getAllEmployeeRecordsInformation = (payload) => {
  return apiInstance().get(
    `${endPoints.reports.getAllEmployeeRecords}/${payload.fileId}/${payload.searchString}/${payload.pageNumber}`
  );
};

export const getEmployeePayDateLevelTransactionDetails = (payload) => {
  return apiInstance().get(
    `${endPoints.reports.getEmployeeTransactionDetails}/${payload.fileId}/${payload.employeeId}/${payload.planId}/${payload.payDate}`
  );
};
export const getDataChangeInformationById = (payload) => {
  return apiInstance().get(
    `${endPoints.reports.getDataChangeInformation}/${payload.fileId}/${payload.pageNumber}`
  );
};
export const getMasterLoanTypes = (companyId) => {
  return apiInstance().get(
    `${endPoints.reports.getMasterLoanTypes}/${companyId}`
  );
};
export const downloadAllFileEmployeeDetails = (payload) => {
  return fileApiInstance().get(
    `${endPoints.reports.getDownloadAllFileEmployeeDetails}/${payload.searchString}/${payload.fileId}`
  );
};
export const downloadDataChangeReportById = (fileId) => {
  return fileApiInstance().get(
    `${endPoints.reports.downloadDataChangeReport}/${fileId}`
  );
};

export const getDataOverrideInformationById = (payload) => {
  return apiInstance().get(
    `${endPoints.reports.getDataOverrideInformation}/${payload.fileId}/${payload.pageNumber}`
  );
};

export const getErrorValidationInformationById = (payload) => {
  return apiInstance().get(
    `${endPoints.reports.getErrorValidationInformation}/${payload.fileId}/${payload.pageNumber}`
  );
};

export const getPayrollFundingInformationById = (payload) => {
  return apiInstance().get(
    `${endPoints.reports.getPayrollFundingInformation}/${payload.fileId}/${payload.pageNumber}`
  );
};

export const getInputFileById = (fileId) => {
  return fileApiInstance().get(
    `${endPoints.reports.getDownloadUploadedFileReport}/${fileId}`
  );
};

export const getSubmittedFilebyFileId = (fileId) => {
  return fileApiInstance().get(
    `${endPoints.reports.getDownloadSubmittedFileReport}/${fileId}`
  );
};

export const getSourceLevelPayrollDetailsByFileId = (id) => {
  return apiInstance().get(
    `${endPoints.reports.getSourceLevelPayrollDetailsById}/${id}`
  );
};

//Manage Report

export const getCompaniesDropDown = (payload) => {
  return apiInstance().get(endPoints.reports.getCompaniesList);
};

export const getPlansDropDown = (companyId) => {
  return apiInstance().get(`${endPoints.reports.getPlansList}/${companyId}`);
};

export const getDownloadEligibilityStatusReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadEligibilityStatusReport,
    payload
  );
};
export const getSponsorOrganizationList = () => {
  return apiInstance().get(endPoints.reports.getSponsorOrganizationList);
};
export const getMasterPlanList = (sponsorId) => {
  return apiInstance().get(
    `${endPoints.reports.getMasterPlanList}/${sponsorId}`
  );
};

export const getEligilibilityStatusReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getEligibilityStatusReportInformation,
    payload
  );
};

export const getDownloadEligibilityForecastReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadEligibilityForecastReport,
    payload
  );
};

export const getEligibilityForecastReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getEligibilityForecastReportInformation,
    payload
  );
};

export const getDownload402gReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownload402gReport,
    payload
  );
};

export const get402gReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.get402gReportInformation,
    payload
  );
};

export const getForfeitureSummaryReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getForfeitureSummaryReport,
    payload
  );
};

export const getDownloadContributionDataReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadContributionDataReport,
    payload
  );
};

export const getContributionDataReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getContributionDataReportInfo,
    payload
  );
};
export const getDownloadParticipantUpdatesReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadParticipantUpdatesReport,
    payload
  );
};

export const getParticipantUpdatesReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getParticipantUpdatesReportInfo,
    payload
  );
};

export const getDownloadContributionFlagsReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadContributionFlagsReport,
    payload
  );
};

export const getContributionFlagsReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getContributionFlagsReportInfo,
    payload
  );
};

export const getDownload415Report = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownload415Report,
    payload
  );
};

export const getDownloadLoanRepaymentReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadLoanRepaymentReport,
    payload
  );
};

export const get415ReportInfo = (payload) => {
  return apiInstance().post(endPoints.reports.get415ReportInformation, payload);
};

export const getLoanRepaymentReport = (payload) => {
  return apiInstance().post(endPoints.reports.getLoanRepaymentReport, payload);
};

export const getDownloadDeletedParticipantReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadDeletedParticipantReport,
    payload
  );
};

export const getDeletedParticipantReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getDeletedParticipantReportInformation,
    payload
  );
};
export const GetRehireParticipantsReport = (payload) => {
  return apiInstance().post(
    endPoints.reports.getRehireParticipantsReportInformation,
    payload
  );
};

export const GetCompensationHourLoansReport = (payload) => {
  return apiInstance().post(
    endPoints.reports.getCompensationHoursLoansReportInformation,
    payload
  );
};

export const DownloadCompensationHourLoansReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.downloadCompensationHoursLoansReportInformation,
    payload
  );
};

export const GetNewParticipantEligibilityReport = (payload) => {
  return apiInstance().post(
    endPoints.reports.getNewParticipantEligibilityReportInformation,
    payload
  );
};

export const getEmploymentStatusReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getEmploymentStatusReportInformation,
    payload
  );
};

export const getDownloadEmploymentStatusReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadEmploymentStatusReport,
    payload
  );
};

export const getVestingReductionReport = (payload) => {
  return apiInstance().post(
    endPoints.reports.getVestingReductionReport,
    payload
  );
};

export const getVestingParticipantStatusChange = (payload) => {
  return apiInstance().post(
    `${endPoints.reports.getVestingParticipantStatusChange}`,
    payload
  );
};

export const getDownloadNewParticipantReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadNewParticipantReport,
    payload
  );
};

export const getDownloadRehireReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadRehireReport,
    payload
  );
};
export const getDownloadErrorCountReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadErrorCountReport,
    payload
  );
};

export const getErrorCountReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getErrorCountReportInformation,
    payload
  );
};

export const getDownloadLatePayrollNotificationsReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadLatePayrollNotificationsReport,
    payload
  );
};

export const getLatePayrollNotificationsReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getLatePayrollNotificationsReportInformation,
    payload
  );
};
export const getSponsorDetailsReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getSponsorDetailsReportInformation,
    payload
  );
};

export const getDownloadSponsorDetailsReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadSponsorDetailsReport,
    payload
  );
};

export const getPlanSummaryReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getPlanSummaryReportInformation,
    payload
  );
};

export const getDownloadPlanSummaryReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadPlanSummaryReport,
    payload
  );
};

export const getEligilibilityReportMaster = () => {
  return delay(100).then(() => {
    return EligilibilityReport;
  });
};

export const getEligilibilityForecastMaster = () => {
  return delay(100).then(() => {
    return EligilibilityForecast;
  });
};

// export const getDeletedParticipantMaster = () => {
//   return delay(100).then(() => {
//     return DeletedParticipant;
//   });
// };

export const getGContributionLimitMaster = () => {
  return delay(100).then(() => {
    return GContributionLimit;
  });
};

export const getContributionLimitMaster = () => {
  return delay(100).then(() => {
    return ContributionLimit;
  });
};

export const getEmployementStatusMaster = () => {
  return delay(100).then(() => {
    return EmployementStatus;
  });
};

export const getPayrollCancellation = (payload) => {
  return apiInstance().get(
    `${endPoints.reports.getPayrollCancellation}/${payload}`
  );
};

export const getDownloadPeriodicCensusReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadPeriodicCensusReport,
    payload
  );
};

export const getPeriodicCensusReportInfo = (payload) => {
  return apiInstance().post(endPoints.reports.getPeriodicCensusReport, payload);
};
export const getDownloadPeriodicEmployerContributionReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadPeriodicEmployerContributionReport,
    payload
  );
};
export const generatePeriodicEmployerContributionPayrollFile = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.generatePeriodicEmployerContributionPayrollFile,
    payload
  );
};

export const getPeriodicEmployerContributionReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getPeriodicEmployerContributionReport,
    payload
  );
};
export const getRMDReportInfo = (payload) => {
  return apiInstance().post(endPoints.reports.getRMDReport, payload);
};

export const getDownloadRMDReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadRMDReport,
    payload
  );
};

export const downloadMissedRMDReport = (payload) => {
  return fileApiInstance().post(endPoints.reports.getMissedRMDReport, payload);
};

export const getForceOutReportInfo = (payload) => {
  return apiInstance().post(
    endPoints.reports.getForceOutReportInformation,
    payload
  );
};

export const getDownloadForceOutReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadForceOutReport,
    payload
  );
};

export const downloadAggregatedReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadAggregatedReport,
    payload
  );
};
export const getLoanRepaymentDetailReport = (payload) => {
  return apiInstance().post(
    endPoints.reports.getLoanRepaymentDetailReport,
    payload
  );
};

export const getDownloadLoanRepaymentDetailReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadLoanRepaymentDetailReport,
    payload
  );
};

export const getTopErrorCodes = (payload) => {
  return apiInstance().post(endPoints.reports.getTopErrorCodes, payload);
};

export const getFileUploadedReport = (payload) => {
  return apiInstance().post(endPoints.reports.getFileUploadedReport, payload);
};

export const getEmployeeTransactionReport = (payload) => {
  return apiInstance().post(
    endPoints.reports.getEmployeeTransactionReport,
    payload
  );
};

export const getPlanTransactionReport = (payload) => {
  return apiInstance().post(
    endPoints.reports.getPlanTransactionReport,
    payload
  );
};

export const getMapperTransactionReport = (payload) => {
  return apiInstance().post(
    endPoints.reports.getMapperTransactionReport,
    payload
  );
};

export const getEnrollmentReviewReport = (payload) => {
  return apiInstance().post(
    endPoints.reports.getEnrollmentReviewReport,
    payload
  );
};

export const downloadEnrollmentReviewReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.downloadEnrollmentReviewReport,
    payload
  );
};

export const get316ReportInfo = (payload) => {
  return apiInstance().post(endPoints.reports.get316ReportInfo, payload);
};

export const download316ReportInfo = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.download316ReportInfo,
    payload
  );
};
export const downloadPayrollCalendarEndDate = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.downloadPayrollCalendarEndDateReport,
    payload
  );
};

export const getReportStatusForNonPayPeriod = (payload) => {
  return apiInstance().post(
    endPoints.reports.getReportStatusForNonPayPeriod,
    payload
  );
};

export const getNonPayPeriodReportData = (payload) => {
  return apiInstance().post(
    endPoints.reports.getNonPayPeriodReportData,
    payload
  );
};

export const downloadNonPayPeriodReport = (
  rkPlanNumber,
  sourceName,
  reportId
) => {
  return fileApiInstance().get(
    `${endPoints.reports.downloadNonPayPeriodReport}/${rkPlanNumber}/${sourceName}/${reportId}`
  );
};
export const downloadReportNonPayPeriod = (planId, SourceName, ReportId) => {
  return fileApiInstance().get(
    `${endPoints.reports.downloadReportNonPayPeriod}/${planId}/${SourceName}/${ReportId}`
  );
};
export const ExportOutputFiles = (payload) => {
  return fileApiInstance().post(endPoints.payroll.exportOutputFiles, payload);
};

export const downloadMapperListReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadMapperListReport,
    payload
  );
};

export const downloadPayrollFrequencyReport = (payload) => {
  return fileApiInstance().post(
    endPoints.reports.getDownloadPayrollFrequencyReport,
    payload
  );
};